import PersonalInfo from "./PersonalInfoContainer";

export default PersonalInfo;
